import React from 'react';
import { EventCommitment } from 'interfaces/types.interface';
import { ChainsIcon } from '@common_components/icons/chains.icon';
import { ArchiveBoxIcon, BookIcon, CheckIcon, FileIcon, RecurringIcon } from '@umanforge/common';
import CompletionIndicator from './completionIndicator.component';

const EngagementStatusIcons: React.FC<{ engagement: EventCommitment, lightMode?: boolean }> = ( { engagement, lightMode = false } ) => {
  return (
    <div className="flex gap-2 h-fit z-10 items-center px-2 py-2 flex-wrap">
      {engagement.completed && (
        <CheckIcon className="h-5 w-5 bg-green-300 text-green-700 p-0.5 rounded-md" />
      )}
      {
        !lightMode && (
          <>
            {engagement.haveNote && (
              <BookIcon className="h-5 w-5 bg-blue-300 text-blue-700 p-0.5 rounded-md" />
            )}
            {engagement.haveDocument && (
              <FileIcon className="h-5 w-5 bg-blue-300 text-blue-700 p-0.5 rounded-md" />
            )}
          </>
        )
      }
      {engagement.isEventRecurring && (
        <RecurringIcon className="h-5 w-5 bg-orange-300 text-orange-700 p-0.5 rounded-md" />
      )}
      {engagement.participants.length > 1 && (
        <ChainsIcon size={5} className="bg-orange-300 text-orange-700 p-[3px] rounded-md" />
      )}
      {engagement.archived && (
        <ArchiveBoxIcon className="h-5 w-5 bg-purple-300 text-purple-700 p-0.5 rounded-md" />
      )}
      <CompletionIndicator percentage={ engagement.complatedPercentage } displayPourcent={ !lightMode } />
      {engagement.numberOfLateDays > 0 && (
        <div className="flex-center absolute -top-2 -right-2 rounded font-texte aspect-square h-6 flex justify-start bg-red-500 font-semibold text-white items-center">
          {engagement.numberOfLateDays}
        </div>
      )}
    </div>
  );
};

export default EngagementStatusIcons;
